module.exports = __webpack_public_path__ + "img/number_2.23c7d8a9.png";